import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';

@Component({
    selector: 'app-edit-template-name',
    templateUrl: './edit-template-name.component.html',
    styleUrls: ['./edit-template-name.component.scss'],
    standalone: false
})
export class EditTemplateNameComponent implements OnInit, OnChanges {
  @Input() templateName: string = '';
  @Input() isTemplateNameBeingEdited: boolean = false;
  @Input() showEditIcon: boolean = true;
  
  @Output() templateNameChange = new EventEmitter<string>();
  @Output() editModeChange = new EventEmitter<boolean>();

  private currentTemplateName: string = '';

  ngOnInit(): void {
    this.currentTemplateName = this.templateName;
  }

  ngOnChanges(): void {
    this.currentTemplateName = this.templateName;
  }

  toggleTemplateNameEditMode(): void {
    if (this.isTemplateNameBeingEdited && this.currentTemplateName === '') {
      // Handle empty template name error
      return;
    }
    this.editModeChange.emit(!this.isTemplateNameBeingEdited);
  }

  onTemplateNameChange(event: { target: { value: string } }): void {
    this.currentTemplateName = event.target.value;
    this.templateNameChange.emit(this.currentTemplateName);
  }

  saveTemplateName(): void {
    if (this.currentTemplateName.trim() === '') {
      // Don't save empty template name
      return;
    }
    this.templateNameChange.emit(this.currentTemplateName);
    this.editModeChange.emit(false);
  }
} 